import React from 'react';
import { Carousel } from 'react-bootstrap';
import './ImageCarousel.css';

const ImageCarousel = ({ images }) => {
  if (!images || images.length === 0) {
    return <div className="image-carousel-placeholder">Aucune image disponible</div>;
  }

  return (
    <Carousel interval={null} className="custom-image-carousel" fade>
      {images.map((img, index) => (
        <Carousel.Item key={img.id || index} className="carousel-item-custom">
          <img
            className="d-block w-100 carousel-image-custom"
            src={img.url || img} // Handle both object {url: string} and direct string url
            alt={`Slide ${index}`}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;